import { Routes, Route, Navigate } from "react-router-dom";
import { AppShell } from "./app-shell/AppShell";
import { NAV_ITEMS } from "./app-shell/navigation";
import { ExecutiveDashboard } from "./features/dashboard/ExecutiveDashboard";
import { EngineScreen } from "./features/engine/EngineScreen";
import { ProductDevelopmentScreen } from "./features/product-development/ProductDevelopmentScreen";
import { CredentialsScreen } from "./features/security/CredentialsScreen";
import { MarketplaceScreen } from "./features/marketplace/MarketplaceScreen";
import { AiScreen } from "./features/ai/AiScreen";
import { ProductScreen } from "./features/product/ProductScreen";
import { CustomerScreen } from "./features/customer/CustomerScreen";
import { SupplierScreen } from "./features/supplier/SupplierScreen";
import { SalesScreen } from "./features/sales/SalesScreen";
import { InventoryScreen } from "./features/inventory/InventoryScreen";
import { PurchaseScreen } from "./features/purchase/PurchaseScreen";
import { PricingScreen } from "./features/pricing/PricingScreen";
import { LogisticsScreen } from "./features/logistics/LogisticsScreen";
import { MarketTrendsScreen } from "./features/market-trends/MarketTrendsScreen";
import { AnalyticsScreen } from "./features/analytics/AnalyticsScreen";
import { AccountsScreen } from "./features/accounts/AccountsScreen";

/** Secciones con pantalla dedicada (no usan el EngineScreen genérico). */
const DEDICATED = new Set(["product-development", "security", "marketplace", "ai", "product", "customer", "supplier", "sales", "inventory", "purchase", "pricing", "logistics", "market-trends", "analytics"]);

const ENGINE_SUBTITLES: Record<string, string> = {
  product: "Fuente única de verdad de tu catálogo de productos.",
  marketplace: "Publicaciones, cuentas y sincronización con Mercado Libre.",
  sales: "Órdenes, cotizaciones y ciclo comercial de punta a punta.",
  pricing: "Reglas de precio, márgenes y promociones del negocio.",
  inventory: "Stock vendible, bodegas, lotes y reservas en tiempo real.",
  purchase: "Órdenes de compra, recepciones y abastecimiento.",
  supplier: "Ficha maestra de proveedores, contratos y evaluación.",
  logistics: "Despachos, rutas y seguimiento de entregas.",
  customer: "Clientes, segmentación, fidelización y crédito.",
  finance: "Contabilidad, IVA, tesorería y estados financieros.",
  analytics: "KPIs, tableros y business intelligence del negocio.",
  ai: "Plataforma de IA: inferencia, RAG, agentes y gobernanza.",
};

export function App(): JSX.Element {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<ExecutiveDashboard />} />
        <Route path="/desarrollo-producto" element={<ProductDevelopmentScreen />} />
        <Route path="/seguridad" element={<CredentialsScreen />} />
        <Route path="/marketplace" element={<MarketplaceScreen />} />
        <Route path="/ia" element={<AiScreen />} />
        <Route path="/producto" element={<ProductScreen />} />
        <Route path="/clientes" element={<CustomerScreen />} />
        <Route path="/proveedores" element={<SupplierScreen />} />
        <Route path="/ventas" element={<SalesScreen />} />
        <Route path="/inventario" element={<InventoryScreen />} />
        <Route path="/compras" element={<PurchaseScreen />} />
        <Route path="/precios" element={<PricingScreen />} />
        <Route path="/logistica" element={<LogisticsScreen />} />
        <Route path="/tendencias" element={<MarketTrendsScreen />} />
        <Route path="/analytics" element={<AnalyticsScreen />} />
        <Route path="/cuentas" element={<AccountsScreen />} />
        {NAV_ITEMS.filter((item) => item.id !== "dashboard" && !DEDICATED.has(item.id)).map((item) => (
          <Route
            key={item.id}
            path={item.path}
            element={
              <EngineScreen
                engineId={item.id}
                icon={item.icon}
                subtitle={ENGINE_SUBTITLES[item.id] ?? item.label}
              />
            }
          />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
